<template>
    <div class="wrapper">
        <h2>Log out of your account?</h2>
        <SubmitButton
            @click="submit"
            text="Log Out"
        />
    </div>
</template>

<script>
import { auth } from '../../db'

export default {
    name: 'LogOut',
    methods: {
        submit() {
            auth.signOut()
                .catch(e => console.log(e.message))
                .finally(() => {
                    this.$router.push('/home')
                })
            
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../interface.scss';
</style>